<template>
  <div>
    <component :is="dynamicComponent" />
    <router-view />
    <update-snackbar />
  </div>
</template>


//For Update Forcely
<script>
import { mapGetters } from "vuex";
import "@fortawesome/fontawesome-free/css/all.css";
import "@/assets/icomoon/style.css";
import UpdateSnackbar from "@/components/UpdateSnackbar.vue";

export default {
  name: "App",
  components: { UpdateSnackbar },
  data() {
    return {
      dynamicComponent: null,
    };
  },
  computed: {
    ...mapGetters({
      theme: "themeMode",
    }),
  },
  created() {
    document.body.classList.toggle(
      "dark-theme",
      localStorage.getItem("mitaThemeMode") === "dark",
    );
    if (this.theme === "dark") {
      import("@/components/theme/DarkTheme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color1") {
      import("@/components/theme/color1Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "default") {
      import("@/components/theme/DefaultTheme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color3") {
      import("@/components/theme/color3Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color4") {
      import("@/components/theme/color4Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color5") {
      import("@/components/theme/color5Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color6") {
      import("@/components/theme/color6Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color7") {
      import("@/components/theme/color7Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color8") {
      import("@/components/theme/color8Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color9") {
      import("@/components/theme/color9Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color10") {
      import("@/components/theme/color10Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color11") {
      import("@/components/theme/color11Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color12") {
      import("@/components/theme/color12Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color13") {
      import("@/components/theme/color13Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color14") {
      import("@/components/theme/color14Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color15") {
      import("@/components/theme/color15Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color16") {
      import("@/components/theme/color16Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color17") {
      import("@/components/theme/color17Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else if (this.theme === "color18") {
      import("@/components/theme/color18Theme").then((module) => {
        this.dynamicComponent = module.default;
      });
    } else {
      import("@/components/theme/DefaultTheme").then((module) => {
        this.dynamicComponent = module.default;
      });
    }
    // }, 1000);
  },
};
</script>

<style lang="sass">
@import "@/assets/styles/dynamic/importer/default.sass"
</style>
